import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import { usePokerSundayMillionWidget } from '../../../model';
import Skeleton from '../../Skeleton/Skeleton';

import {
  TXTCLI_SATELLITES_TO_THE_SUNDAY_MILLI_ELL,
  TXTCLI_Satellites_are_smaller_tournam_ELL
} from './Details.messages.json';
import styles from './Details.scss';

const Details: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const isLoading = useSelector(widgetSelect.isLoading);

  return (
    <div className={styles.root}>
      {isLoading ? (
        <>
          <Skeleton sx={{ width: 350, height: 28 }} />
          <p>
            <Skeleton sx={{ width: 400 }} />
            <Skeleton sx={{ width: 250, margin: '0 auto' }} />
          </p>
        </>
      ) : (
        <>
          <Translation {...TXTCLI_SATELLITES_TO_THE_SUNDAY_MILLI_ELL} tagName="h3" />
          <Translation
            {...TXTCLI_Satellites_are_smaller_tournam_ELL}
            values={{
              0: (
                <CurrencyAmount
                  style="currency"
                  value={55}
                  currency="USD"
                  currencyDisplay="symbol"
                />
              )
            }}
            tagName="p"
          />
        </>
      )}
    </div>
  );
};

export default Details;
